import { NgOptimizedImage, DatePipe, LowerCasePipe, DecimalPipe, TitleCasePipe, NgClass } from '@angular/common';
import { Component, computed, inject, input, InputSignal, OnInit, output, OutputEmitterRef, Signal, signal } from '@angular/core';
import { ReactiveFormsModule, NonNullableFormBuilder, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { provideNativeDateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIcon } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { AmlScanEntity, LatestAmlReport, IngoingTransaction } from '../../../../../../../api/api.model';
import { ConvertNetworkToTokenPipe } from '../../../../../../pipes/convert-netwrok-to-token.pipe';
import { CropWithDotsCenterPipe } from '../../../../../../pipes/crop-with-dots-center.pipe';
import { CopyButtonComponent } from '../../../../../copy-button/copy-button.component';
import { InfoComponent } from '../../../../../info/info.component';
import { IncidentProgressComponent } from './components/incident-progress/incident-progress.component';
import { VariablesService } from '../../../../../../services/variables.service';
import { TriggerIdConvertToCategoryPipe } from '../../../../../../pipes/trigger-id-convert-to-category.pipe';
import { ReportStatusComponent } from '../../../../../report-status/report-status.component';
import { take } from 'rxjs';
import { ApiService } from '../../../../../../../api/api.service';
import { AuthService } from '../../../../../../services/auth.service';
import { CutNumberPipe } from "../../../../../../pipes/cut-number.pipe";

@Component({
  selector: 'app-lea-case',
    imports: [
    NgOptimizedImage,
    MatIcon,
    InfoComponent,
    DatePipe,
    CopyButtonComponent,
    LowerCasePipe,
    ConvertNetworkToTokenPipe,
    CropWithDotsCenterPipe,
    MatSelectModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatButtonModule,
    IncidentProgressComponent,
    TriggerIdConvertToCategoryPipe,
    TitleCasePipe,
    NgClass,
    ReportStatusComponent,
    CutNumberPipe
],
  providers: [
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }
  ],
  templateUrl: './lea-case.component.html',
  styleUrl: './lea-case.component.scss'
})
export class LeaCaseComponent implements OnInit {
  readonly transactionInput: InputSignal<AmlScanEntity<LatestAmlReport>> = input.required();


  readonly transaction = signal<AmlScanEntity<LatestAmlReport> | null>(null);
  readonly listTypeBlock = signal<string[]>([]);
  readonly isLoading = signal<boolean>(false);
  readonly typeExposure = signal<'DIRECT' | 'INDIRECT' | null>(null);
  readonly isOpenTrigger = signal<boolean>(false);
  limitedMinDate: Date = new Date();
  private readonly _fb: NonNullableFormBuilder = inject(NonNullableFormBuilder);
  readonly variablesService: VariablesService = inject(VariablesService);
  private readonly _apiService: ApiService = inject(ApiService);
  readonly authService: AuthService = inject(AuthService);

  readonly userRole: Signal<string> = computed(() => {
    const account = this.authService.accountDto();
    if (account) {
      return account.role;
    } else {
      return '';
    }
  });
  
  readonly isComplianceRole: Signal<boolean> = computed(() => {
    const account = this.authService.accountDto();
    const personalCluster = Boolean(account && account.cluster);
    const corporateCluster = Boolean(account && account.companyDto && account.companyDto.cluster);
    const viewer = account && account.companyDto && account.companyRole === 'VIEWER';
    const personalCompliance = (account && account.accountType === 'PERSONAL' && account.role === 'COMPLIANCE') && personalCluster;
    const companyCompliance = (account && (account.accountType === 'CORPORATE') && corporateCluster && !viewer);
    if (personalCompliance || companyCompliance) {
      return true;
    } else {
      return false;
    }
  });

  form = this._fb.group({
    typeBlock: this._fb.control<string>('', [Validators.required]),
    amount: this._fb.control<string>('', [Validators.required]),
    expired: this._fb.control<string>('', [Validators.required]),
  });

  ngOnInit(): void {
    this.transaction.set(this.transactionInput());
    const transaction = this.transaction();
    console.log(transaction);
    if (transaction && transaction.latestAmlReport && transaction.latestAmlReport) {
      const incomingTransaction = this.asIngoingTransaction(transaction);
      if (incomingTransaction.latestAmlReport.alerts && incomingTransaction.latestAmlReport.alerts.length > 0) {
        const direct = incomingTransaction.latestAmlReport.alerts.some(item => item.exposureType === 'DIRECT');
        if (direct) {
          this.typeExposure.set('DIRECT');
        } else {
          this.typeExposure.set('INDIRECT');
        }
      }
    }
  }

  loadTransaction(): void {
    const transactionUuid = this.transaction()?.uuid;
    if (transactionUuid) {
      this._apiService.getAmlScanByUuid(transactionUuid).pipe(take(1)).subscribe({
        next: (data: AmlScanEntity) => {
        const transaction = {
          ...data,
          latestAmlReport: JSON.parse(data.latestAmlReport)
        }
          this.transaction.set(transaction);
        }
      })
    }
  }

  asIngoingTransaction(transaction: AmlScanEntity<LatestAmlReport>): AmlScanEntity<IngoingTransaction> {
    return transaction as AmlScanEntity<IngoingTransaction>;
  }

  public calcPercentForExposures(value: number): number {
    const transaction = this.transaction();
    if (transaction) {
      return Math.round((value / transaction.amount) * 100 * 100) / 100;
    } else {
      return 0;
    }
  }
}
